export default __webpack_public_path__ + "static/media/welcome_bg_m.3ee1cf77.png";